var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckyouremail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 171,
    viewBox: "0 0 304 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7759 54.7073C86.7759 54.7073 12.2511 28.1288 2.09668 83.1365C-8.05773 138.144 57.3205 175.267 117.475 169.389C177.629 163.512 269.283 93.863 269.283 93.863",
    stroke: "#240630",
    strokeDasharray: "10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.525 92.6519L281.231 100.132L303.544 63.8669L251.498 81.1375L263.23 88.6335",
    fill: "#E8505B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.523 92.6519L303.542 63.8668L263.228 88.6334L263.9 100.162L269.523 92.6519Z",
    fill: "#B73D50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.901 100.162L272.511 94.5628L269.525 92.652L263.901 100.162Z",
    fill: "#240630"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.061 7.7263L69.9968 29.0284L64.24 46.6465C63.4537 48.7105 54.8079 78.9199 57.1773 79.8221L109.324 67.8239L137.277 107.034C139.644 107.934 154.565 82.4811 155.351 80.4171L164.42 64.9139L134.405 9.75875C133.255 8.07908 131.039 7.23487 129.062 7.7263H129.061Z",
    fill: "#B73D50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.018 30.8184C164.112 33.1984 161.495 34.413 159.172 33.5284C156.85 32.6438 155.7 29.997 156.607 27.6171L154.284 26.7325C153.378 29.1124 150.761 30.327 148.437 29.4424C146.115 28.5578 144.966 25.9111 145.873 23.5311L143.549 22.6465C142.643 25.0282 140.027 26.241 137.703 25.3564C135.381 24.4719 134.231 21.8251 135.137 19.4452L132.813 18.5606C131.907 20.9423 129.29 22.1551 126.967 21.2705C124.645 20.3859 123.495 17.7392 124.402 15.3592L122.079 14.4746C121.173 16.8563 118.556 18.0691 116.232 17.1845C113.91 16.2999 112.761 13.6532 113.668 11.2732L111.344 10.3886C110.438 12.7704 107.822 13.9832 105.498 13.0986C103.176 12.214 102.026 9.56723 102.933 7.18726L100.61 6.30269C99.704 8.68265 97.0871 9.8972 94.7633 9.01261C92.4413 8.12802 91.2917 5.48129 92.1991 3.10132L89.2469 1.97803L57.3789 85.7209L136.278 115.746L168.146 32.0031L165.02 30.8132L165.018 30.8184Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.2846,
    y: 0.647323,
    width: 86.6994,
    height: 84.4568,
    rx: 3.5,
    transform: "rotate(21.27 89.2846 0.647323)",
    fill: "white",
    stroke: "#DDDDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.154 76.2743L136.673 63.3143C144.426 59.9111 153.684 59.804 162.133 63.0195C164.118 63.7742 165.247 65.6469 164.655 67.2037L153.698 95.9967L143.16 123.688C142.569 125.243 138.986 126.583 137.001 125.829L124.798 121.185L105.816 79.7845C105.181 78.3997 105.756 76.8868 107.152 76.276L107.154 76.2743Z",
    fill: "#E8505B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.343 75.5431L91.9076 46.2376C88.3798 38.5413 81.5347 32.3053 73.0838 29.0899C71.0987 28.3352 69.0101 28.9829 68.4186 30.5379L57.4613 59.331L46.7953 87.3605C46.2039 88.9155 47.722 91.8536 49.7071 92.6083L62.3055 97.3577L104.008 79.0499C105.403 78.4374 105.979 76.9262 105.343 75.5414V75.5431Z",
    fill: "#E8505B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.56 112.126L142.925 124.307C142.232 126.127 139.75 126.873 137.382 125.972L49.7061 92.6072C47.3385 91.7069 45.98 89.5007 46.6733 87.6788L51.3086 75.4982L107.355 64.9603C108.268 64.7883 109.244 64.8866 110.148 65.2025C111.153 65.5536 112.066 66.1749 112.698 66.9928L147.559 112.126H147.56Z",
    fill: "#E8505B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2428 70.4193L100.552 65.0942L101.037 66.1491L51.3086 75.4987L53.2428 70.4193Z",
    fill: "#B73D50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.492 107.047L117.693 71.6157L116.629 72.0826L147.56 112.126L149.492 107.047Z",
    fill: "#B73D50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckyouremail);
export default __webpack_public_path__ + "static/media/checkyouremail.391c405e9fe7d139a241c8a4f0cc4f23.svg";
export { ForwardRef as ReactComponent };